import React from 'react';

import { Box } from '@lightspeed/flame/Core';

import { createReactRenderer } from 'helpers/react-renderer';
import { NotificationBadge } from 'root/apps/components/Notifications/NotificationBadge';
import { TileKey, useNotificationData } from 'root/apps/components/Notifications/utils';

type TileNotificationCountProps = {
  tileKey: TileKey;
  className?: string;
};

/**
 * Generic tile notification count component.
 *
 * Reads notification data from localStorage using the provided tileKey.
 * Another component (e.g., SidebarMASNotificationBadge) is responsible for
 * fetching notifications from the API and persisting them to localStorage.
 */
export default function TileNotificationCount({ tileKey, className }: TileNotificationCountProps) {
  const { count, style } = useNotificationData(tileKey);

  // Validate tileKey from BE is defined and not empty
  if (!tileKey || tileKey.trim() === '') {
    return null;
  }

  if (count <= 0) {
    return null;
  }

  return (
    <Box
      data-test="tile-notification-count-badge"
      data-tile-key={tileKey}
      data-count={count}
      data-style={style}
      className={className}
      style={{ position: 'absolute', zIndex: 10, top: '-8px', right: '6px' }}
    >
      <NotificationBadge count={count} style={style} data-test="tile-notification-pill-badge" />
    </Box>
  );
}

const RenderedComponent = createReactRenderer({
  component: TileNotificationCount,
  selector: '[data-react-root="TileNotificationCount"]',
});

history.onChangeState(
  { tab: undefined, form_name: 'ui_tab', id: undefined },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
